import Styles from './app_error.module.css';
import { DEFAULT_MESSAGES, TEST_ID } from './app_error.constants';
import { prettyPrint } from '../../utilities/pretty_print';

type Props = Readonly<{
  error?: string;
  data?: unknown;
}>;

function DataContainer({ data }: Readonly<{ data: unknown }>) {
  if (!data) {
    return null;
  }
  return (
    <div data-testid={TEST_ID.DataContainer}>
      <pre>{prettyPrint(data)}</pre>
    </div>
  );
}

export function AppError({ error = DEFAULT_MESSAGES.error, data }: Props) {
  return (
    <div data-testid={TEST_ID.ErrorContainer} className={Styles.container}>
      <details>
        <summary data-testid={TEST_ID.SummaryContainer}>{error}</summary>
        <DataContainer data={data} />
      </details>
    </div>
  );
}

export default AppError;
